/**
 * Localization settings
 */

import { UI_TO_CMS_MAP } from '../../common/cms/cmsLocaleConstants';
import { ExperimentId } from '../../common/experiments/experimentsConstants';

export type LocaleOption = {
    id: string;
    label: string;
};

type AppLocaleConfig = LocaleOption & {
    experimentId?: ExperimentId;
};

export type IsLocaleExperimentEnabled = (experimentId: ExperimentId) => boolean;

const APP_LOCALE_CONFIGS: AppLocaleConfig[] = [
    { id: UI_TO_CMS_MAP.en, label: 'English' },
    { id: UI_TO_CMS_MAP.es, label: 'Español' },
    { id: UI_TO_CMS_MAP.fr, label: 'Français' },
    { id: UI_TO_CMS_MAP.pt, label: 'Português' },
    { id: UI_TO_CMS_MAP.de, label: 'Deutsch', experimentId: ExperimentId.appLocaleGerman },
    {
        id: UI_TO_CMS_MAP.zh,
        label: '简体中文',
        experimentId: ExperimentId.appLocaleChineseSimplified,
    },
    { id: UI_TO_CMS_MAP.ru, label: 'Русский', experimentId: ExperimentId.appLocaleRussian },
    { id: UI_TO_CMS_MAP.pl, label: 'Polski', experimentId: ExperimentId.appLocalePolish },
    { id: UI_TO_CMS_MAP.ja, label: '日本語', experimentId: ExperimentId.appLocaleJapanese },
    { id: UI_TO_CMS_MAP.nl, label: 'Nederlands', experimentId: ExperimentId.appLocaleDutch },
    { id: UI_TO_CMS_MAP.it, label: 'Italiano', experimentId: ExperimentId.appLocaleItalian },
    { id: UI_TO_CMS_MAP.ko, label: '한국어', experimentId: ExperimentId.appLocaleKorean },
];

/**
 * Available app locale options for the user interface.
 * Feature-flagged locales are only included when their experiment is enabled.
 */
export const getAppLanguageOptions = (isLocaleExperimentEnabled?: IsLocaleExperimentEnabled): LocaleOption[] => {
    return APP_LOCALE_CONFIGS.filter(({ experimentId }) => {
        if (!experimentId) return true;
        if (!isLocaleExperimentEnabled) return false;

        return isLocaleExperimentEnabled(experimentId);
    }).map(({ id, label }) => ({ id, label }));
};

export const SUPPORTED_APP_LANGUAGE_CODES = Object.keys(UI_TO_CMS_MAP) as (keyof typeof UI_TO_CMS_MAP)[];
